import React, { useContext } from 'react';

const randomContext = React.createContext();
const randomUpdateContext = React.createContext();

export function useRandom() {
   return useContext(randomContext);
}

export function useRandomUpdate() {
    return useContext(randomUpdateContext)
}

export function RandomProvider({ children }) {

    const [random,setRandom] = React.useState(getRandomArray());
    function setRandomArray(_arr) {

    }

    function getRandomArray() {
        const tmpRandArray = [];
        while (tmpRandArray.length < 4) {
            const randomNum = Math.floor(Math.random() * 4);
            if (!tmpRandArray.includes(randomNum)) {
                tmpRandArray.push(randomNum);
            }
        }

        return tmpRandArray;
    }
    
    return (

        <randomContext.Provider value={random}>
            <randomUpdateContext.Provider value={setRandomArray}>
                {children}
            </randomUpdateContext.Provider>
        </randomContext.Provider>

    )
}